var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pop-up",
    transform: "translate(-1052.000000, -87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(1052.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#000000",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3087372,19.6913085 C10.5098788,19.8928342 10.7851902,20.003848 11.0740331,19.9998981 C11.362876,19.9959482 11.6415579,19.8773586 11.8486976,19.6702493 L17.7513606,13.7684583 L17.7085978,18.3596428 L19.8733394,18.3289577 L19.999851,11.0905154 C20.0048917,10.7893341 19.8817014,10.5146137 19.6827257,10.3156674 C19.485269,10.1182398 19.2097267,9.99584886 18.9092821,10.0001077 L11.6697703,10.1266006 L11.6390807,12.2910224 L16.2324624,12.2497845 L10.3297994,18.1515755 C10.1226595,18.3586846 10.0040524,18.6373254 10.0001019,18.9261256 C9.99615145,19.2149258 10.1071817,19.4901966 10.3087372,19.6913085 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(15.000000, 15.000000) scale(1, -1) translate(-15.000000, -15.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmShort);
export default __webpack_public_path__ + "static/media/confirm-short.a1aa915e22e3c96275ae3a3355e556c4.svg";
export { ForwardRef as ReactComponent };